































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import BaseContainer from '@/components/BaseContainer.vue';
import PageDescribe from '@/components/PageDescribe.vue';
import ButtonPanel from '@/components/ButtonPanel.vue';
import publicFunc from '../../common/util/publicFunc';
import AddressSelect from '@/components/AddressSelect.vue';
import { PaginationPanel } from '@/components';
import { CspInquiry, Inquiry, AddressBookApi, Carrier, yun, ProjectManager,Area } from '@/http';
import { type } from '@/http/interface';
import { enums } from '@/common/enums';
import { formRules } from '@/common/util/validator';
import { upload } from '@/common/util/ossUploadService';
import { time } from '@/common/util/time';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
interface goodsFormPayload {
    goodsList: Array<goodsListPayload>;
}
interface goodsListPayload {
    goodsName: string;
    quantity: number;
    unit: number;
    goodsId: string;
}
@Component({
    components: {
        BaseContainer,
        PageDescribe,
        ButtonPanel,
        AddressSelect,
        PaginationPanel,
    },
})
export default class AddInquiry extends Vue {
    public loading: boolean = false;
    public rePagin = false;
    public keyIndex = 0;
    public cspdiaStatus: boolean = true;
    public addressChooseVisible: boolean = false;
    public carrierCategoryType = enums.carrierCategoryType;
    public carriageWayType = enums.carriageWayType;
    public orderState = enums.orderState;
    public shippingOrderState = enums.shippingOrderState;
    public shippingTypeState = enums.shippingTypeState;

    public istState3 = enums.istState3;

    public goodsUnitType = enums.goodsUnitTypeNum;
    public freightUnitType = enums.freightUnitType;
    public pricingModeType = enums.pricingModeType;
    public freightSourceList = enums.freightSourceList;
    public grossWeight = enums.grossWeightList;


    public isChangeMileage = true;
    public formData: any = {
        originTransitArea: '',
        arrivalTransitArea: '',
        subOrderNo: '',
        orderType: 2,
        customerBaseName: '',
        customerBaseCode: '',
        customerBaseId: '',
        shipOrderNo: '',
        shippingOrderType: '',
        shippingType: 1,
        logisticsTaskNo: '',
        carpoolFlag: false,
        shipperCode:'',
        carLength: '',
        vehicleType: '',
        vehicleCount: '',
        loadingEffect: '',
        content: '',
        attachmentList: [
            {
                id: '',
                name: '',
                path: '',
                dataId: '',
                tag: '',
                table: ''
            }
        ],
        originProvince: '',
        originCity: '',
        originCounty: '',
        originDetails: '',
        originAddress: '',
        shipperId: '',
        shipperName: '',
        shipperContactName: '',
        shipperContactPhone: '',
        latestDeliveryTime: '',
        arrivalProvince: '',
        arrivalCity: '',
        arrivalCounty: '',
        arrivalDetails: '',
        arrivalAddress: '',
        consigneeName: '',
        consigneeCode: '',
        consigneeId: '',
        consignee: '',
        consigneePhone: '',
        latestArrivalTime: '',
        planTotalWeight: '',
        orderGoodsList: [
            {
                deliveryOrderNo: '',
                deliveryLine: '',
                materialsCode: '',
                materialsName: '',
                planQuantity: '',
                PlanWeight: '',
                fabricWidth: '',
                storageCode: '',
                sort: 1,
            }
        ]
    };

    public carLengthOptions: any = [];
    public vehicleTypeOptions: any = [];

    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    // public allweight:any = 0
    public type: any = '';
    public id: any = '';
    public carrierList: any = [];
    public contactArr: any = [];
    public canedit:any = false
    async getOrdergetDetaill(data) {
        this.canedit = false
        this.isChangeMileage = false;
        this.selectReset = false;
        this.selectReset2 = false;
        let res = await yun.OrdergetDetaill(data);
        this.formData = res;
        // Object.keys(res).forEach((key) => {
        //     this.formData[key] = res[key];
        // });
        this.$refs.formData.resetFields();
        if (res.isFromTMS && this.$route.query.type =='edit') {
            this.canedit = true
        }
        let resdd = await yun.ShipperGetList({
            equalName: this.formData.customerBaseName,
            type: 1,
            count: 30,
        });
        if (resdd.length == 0) {
            this.formData.customerBaseId = ''
            this.formData.customerBaseCode = ''
            this.formData.customerBaseName = ''
        }
        if (res.originProvince) {
            this.SelectAddress1.province.value = res.originProvince;
            this.SelectAddress1.city.value = res.originCity;
            this.SelectAddress1.area.value = res.originCounty;
        }
        this.selectReset = true;
        this.formData.arrivalAddress = '';
        if (res.arrivalProvince) {
            this.SelectAddress2.province.value = res.arrivalProvince;
            this.SelectAddress2.city.value = res.arrivalCity;
            this.SelectAddress2.area.value = res.arrivalCounty;
        }
        this.formData.originAddress = '';
        this.selectReset2 = true;
        this.currentBtn = [];
        this.getLoadTypeList.forEach((datas) => {
            res.loadingEffect.split(',').forEach((dd) => {
                if (dd == datas.name) {
                    this.currentBtn.push(datas);
                }
            });
        });
        // this.formData.planWeight = 0
        if (res.orderGoodsList.length) {
            let skip = 0
            this.goodsForm.goodsList = res.orderGoodsList;
            this.goodsForm.goodsList.map((item, index) => {
                item.index = skip++ + 1;
            });
        }
        res.attachmentList.forEach((dds) => {
            this.fileList.push({
                name: dds.name,
                url: dds.path,
            });
        });
        // this.fileList.push({
        //         name: res.attachements.name,
        //         url: res.attachements.path,
        //     });
        // this.fileList = res.attachements.map((list) => {
        //     return {
        //         name: list.name,
        //         url: list.url,
        //     };
        // });
        console.log('currentBtn', this.currentBtn);
        this.formData.freightSource = ''
        this.formData.carrierName = ''
        this.formData.carrierId = ''
        if (this.$route.query.type == 'copy') {
            this.formData.subOrderNo = ''
            this.formData.shipOrderNo = ''
            this.formData.logisticsTaskNo = ''
            this.formData.carpoolFlag = false
        }
    }
    // 发货计划
    public async getOrderData(id){
        this.selectReset = false
        this.selectReset2 = false;
        let res = await ProjectManager.GetProjectDetail(id);
        let res2 = await ProjectManager.GetInquiryByProjectCode({projectCode:res.projectCode});
        this.formData.inquiryCode  = res2.inquiryCode;
        this.formData.projectCode = res.projectCode;
        this.formData.arrivalDetails = res.arrivalDetails;
        this.formData.arrivalProvince = res.arrivalProvince;
        this.formData.arrivalCity = res.arrivalCity;
        this.formData.arrivalCounty = res.arrivalCounty;
        this.SelectAddress2.province.value = res.arrivalProvince;
        this.SelectAddress2.city.value = res.arrivalCity;
        this.SelectAddress2.area.value = res.arrivalCounty;
        this.formData.content = res.otherInfo;
        this.formData.consignee = res.consignee;
        this.formData.consigneePhone = res.consigneePhone;
        this.selectReset2 = true;
        this.selectReset = true;
        res.attachements.forEach((dds) => {
            this.fileList.push({
                name: dds.name,
                url: dds.url,
            });
        });
        if (res.goodsList.length) {
            this.goodsForm.goodsList = res.goodsList;
            this.goodsForm.goodsList[0].model = res.goodsList[0].model;
            let skip = 0;
            this.goodsForm.goodsList = res.goodsList;
            this.goodsForm.goodsList.map((item, index) => {
                item.index = skip++ + 1;
            });
        }
        // 计算货物总重量
        this.changeww();
        let res3 = await AddressBookApi.GetAddressBookList({
            addressType:1,
        });
        this.formData.clientName = res3.addressDetailList[0].contactName;
        this.formData.clientPhone = res3.addressDetailList[0].phoneNumber;
        this.formData.originDetails = res3.addressDetailList[0].detail
        this.SelectAddress1.province.value  = res3.addressDetailList[0].province;
        this.SelectAddress1.city.value = res3.addressDetailList[0].city;
        this.SelectAddress1.area.value = res3.addressDetailList[0].district;

    }
    //一键发货
    public async getInquiryData(id) {

        let res = await Inquiry.GetDetail(id);
        this.formData.inquiryCode  =res.code;
        this.formData.projectCode = res.projectCode
        this.formData.vehicleType = res.vehicleType;
        this.formData.vehicleCount = res.carCount;
        this.formData.carriageWay = res.carriageWay;
        this.formData.content = res.otherRequire;
        this.formData.mileage = res.mileage;
        this.formData.clientName = res.contact;
        this.formData.estArrivalTime = res.preUnloadTime;
        this.formData.clientPhone = res.contactPhone;
        this.formData.estDeliveryTime = res.preDeliveryTime;
        this.formData.originDetails = res.deliveryAddressDetail;
        this.formData.arrivalDetails = res.arrivalAddressDetail;
        this.isChangeMileage = false;
        this.SelectAddress1.province.value = res.deliveryProvinceCode;
        this.formData.originProvince = res.deliveryProvinceCode
        this.SelectAddress1.city.value = res.deliveryCityCode;
        this.formData.originCity = res.deliveryCityCode
        this.SelectAddress1.area.value = res.deliveryAreaCode;
        this.formData.originCounty = res.deliveryAreaCode
        this.selectReset = true;
        this.SelectAddress2.province.value = res.arrivalProvinceCode;
        this.formData.arrivalCounty = res.arrivalAreaCode
        this.SelectAddress2.city.value = res.arrivalCityCode;
        this.formData.arrivalCity = res.arrivalCityCode
        this.SelectAddress2.area.value = res.arrivalAreaCode;
        this.formData.arrivalCounty = res.arrivalAreaCode;
        this.formData.arrivalProvince = res.arrivalProvinceCode;
        this.formData.freightUnitPrice = res.winPrice;
        this.formData.freightUnit = 1;
        this.selectReset2 = true;
        if (res.goodsList.length) {
            this.goodsForm.goodsList = res.goodsList;
        }
        res.attachements.forEach((dds) => {
            this.fileList.push({
                name: dds.name,
                url: dds.url,
            });
        });
        this.formData.carrierName = res.winner;
        this.formData.carrierId = res.winnerId;
        this.GetPrice();
        if (res.carLengthValueList.length == 1) {
            this.formData.carLength = res.carLength;
        }
        this.changeww()
    }
    async loadadd() {
        // this.selectReset = false;
        // this.selectReset2 = false;
        // setTimeout(async (_) => {
        //     this.addressType = 1;
        //     let res = await AddressBookApi.GetAddressBookList({
        //         addressType: this.addressType,
        //         isDefault: false,
        //         skip: this.searchPagin.skip,
        //         count: this.searchPagin.count,
        //     });
        //     console.log('res', res.addressDetailList[0]);
        //     if (res.addressDetailList[0].isDefault) {
        //         this.saveAddress(res.addressDetailList[0]);
        //     }
        //     this.addressType = 2;
        //     let resd = await AddressBookApi.GetAddressBookList({
        //         addressType: this.addressType,
        //         isDefault: false,
        //         skip: this.searchPagin.skip,
        //         count: this.searchPagin.count,
        //     });
        //     console.log('resd', resd.addressDetailList[0]);
        //     if (resd.addressDetailList[0].isDefault) {
        //         this.saveAddress(resd.addressDetailList[0]);
        //     }
        // }, 10);
    }
    public async created() {
        this.getLoadType();
        this.type = this.$route.query.type;
        this.id = this.$route.query.id;
        this.selectReset = true;
        this.selectReset2 = true;
        this.contactArr = JSON.parse(localStorage.getItem('contactArr'));
        if (this.contactArr) {
            this.formData.contact = this.contactArr[0].contact;
            this.formData.contactPhone = this.contactArr[0].contactPhone;
        }

        if (this.$refs.formData) {
            this.$refs.formData.resetFields();
        }
        this.carLengthOptions = await Inquiry.GetDicDetailList({
            typeName: 'carModel',
            count: -1,
        });
        this.vehicleTypeOptions = await Inquiry.GetDicDetailList({
            typeName: 'carType',
            count: -1,
        });
        let res = await Carrier.GetList({ count: -1 });
        this.carrierList = res.data;
        this.selectReset = false;
        this.selectReset2 = false;
        if (this.$route.query.type == 'edit' || this.$route.query.type == 'copy') {
           await this.getOrdergetDetaill(this.$route.query.id);
           


        } else if (this.$route.query.inquiryId) {
            this.getInquiryData(this.$route.query.inquiryId);
        }else if(this.$route.query.type == 'projectplan'){
            this.getOrderData(this.$route.query.projectplanid)
        }
        else {
            this.loadadd();
        }
    }
    /**删除询价单 */
    deleteInquiry() {
        this.$confirm('确认删除该询价单?', '询价单删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        })
            .then(() => {
                Inquiry.DelInquiry(this.id).then(() => {
                    this.$message.success('询价单删除成功');
                    this.$router.push('/SingleInquiry');
                });
            })
            .catch(() => {});
    }

    public sssingin(data,index) {
        this.sssing = index
        this.formData.freightUnitPrice = data.priceValue
        if (this.formData.pricingMode == 1){
            this.formData.freightUnit = 1
        } else {
            this.formData.freightUnit = 2
        }
    }
    public carrierVisible:any = false
    public sssing:any = ''
    public carLengthList:any = []
    public vehicleTypeList:any = []
    public hascarrier:any = false
    public cars:any = []
    public sscar:any = ''
    public async addCarrier () {
        this.formData.orderGoodsList = this.goodsForm.goodsList;
        if (this.formData.orderGoodsList.length == 0) {
            this.$alert('货物信息不能少于1条');
            return;
        }
        let istabe: any = false;
        this.formData.orderGoodsList.forEach((item) => {
            if (item.planWeight) {
                try {
                    let nn = (item.planWeight + '').split('.')[1];
                    if (nn.length > 4) {
                        item.planWeight = Number((item.planWeight + '').split('.')[0] + '.' + nn.slice(0, 4));
                    }
                } catch (e) {}
                if (!Number(item.planWeight+ '')) {
                    item.planWeight = ''
                }else {
                    item.planWeight = Number(item.planWeight)
                }
            }
            if (!item.materialsName) {
                istabe = true;
            }
        });

        if (istabe) {
            this.$alert('请把货物信息填写正确完整');
            return;
        }
        this.formData.attachmentList = this.fileList.map((v) => {
            return {
                name: v.name,
                path: v.url,
            };
        });

        this.formData.loadingEffect = '';

        console.log(this.currentBtn);
        this.currentBtn.forEach((data) => {
            console.log('data', data.name);
            this.formData.loadingEffect = this.formData.loadingEffect + data.name + ',';
        });
        console.log('this.formData', this.formData);
        console.log(this.formData.originAddress, this.originProvince, this.originCity, this.originCounty);
        // return
        let address1 = this.$refs.address1.validateForm();
        let address2 = this.$refs.address2.validateForm();
        // let goodsForm = this.goodsListvalidateForm();
        this.$refs.formData.validate(async (valid) => {
            if (address1 && address2 && this.formData.orderGoodsList.length && valid) {
                console.log('this.formData' + this.formData);
                this.carrierVisible = true
                this.sssing = ''
                let resd = await yun.GetFreight({
                    inquiryCode: this.formData.inquiryCode,
                })
                console.log(resd)
                this.formData.carriageWay = resd.carriageWay ? resd.carriageWay: this.formData.carriageWay
                if (resd.carrierId)  {
                    this.carrierId1 = resd.carrierId
                    this.carrierName1 = resd.carrierName
                    this.hascarrier = true
                }

                this.CarriageWay1 = resd.carriageWay
                this.cars = []
                if (resd.cars) {
                    this.cars = resd.cars
                }
            }
        });
    }
    public carrierId1 =''
    public carrierName1 =''
    public CarriageWay1:any = ''
    carss(index,resd) {
        this.sscar = index
        this.formData.freightUnitPrice = resd.singlePrice ? resd.singlePrice: this.formData.singlePrice
        this.formData.freightUnit = 1
    }
    public freightSourceChange() {
        this.formData.carrierId = ''
        this.formData.carrierName = ''
        this.formData.freightUnitType = ''
        this.formData.freightUnitPrice = ''
        this.formData.pricingMode = ''
        if (this.formData.freightSource == 1) {
            this.formData.carrierId =  this.carrierId1
            this.formData.carrierName = this.carrierName1
            this.formData.pricingMode = 1
        }
    }
    public final() {
        this.$confirm('确认终结该询价单?', '询价单终结', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        })
            .then(() => {
                Inquiry.EndInquiry(this.id).then(() => {
                    this.$message.success('询价单终结成功');
                    this.$router.push('/SingleInquiry');
                });
            })
            .catch(() => {});
    }

    public cspdiaConfig: any = {
        cspDialogVisible: false,
        title: '询价单发布',
        content: '确认发布询价单？',
    };
    public loadingType = enums.loadingTypeNum;
    public unitType = enums.goodsUnitType;
    public formRules = formRules;
    /** */
    public $refs: {
        formData: HTMLFormElement;
        address1: HTMLFormElement;
        address2: HTMLFormElement;
        goodsForm: HTMLFormElement;
        pagination: HTMLFormElement;
    };

    public carLengthChange(data) {
        this.carLengthList = [];
        data.forEach((item) => {
            let res = this.carLengthOptions.filter((v) => v.value == item)[0];
            this.carLengthList.push({
                carLength: res.name,
                carLengthValue: res.value,
            });
        });
    }

    public carrierChange(data) {
        this.GetPrice();
    }
    public dynamicTags = [];

    public addressType = 1;
    public async saveAddress(row) {
        if(!row.province) {
            return
        }
        if (this.addressType == 1) {
            console.log('11');
            this.selectReset = false;
            // this.formData = {
            //     ...this.formData,
            //     deliveryProvinceCode: row.province,
            //     deliveryCityCode: row.city,
            //     deliveryAreaCode: row.district,
            //     dliveryProvince: row.provinceStr,
            //     deliveryCity: row.cityStr,
            //     deliveryArea: row.districtStr,
            //     deliveryAddressDetail: row.detail,
            // };
            this.formData.originProvince = row.province;
            this.formData.originCity = row.city;
            this.formData.originCounty = row.district;
            this.formData.originDetails = row.detail;
            this.formData.shipperContactName = row.contactName;
            this.formData.shipperContactPhone = row.phoneNumber;

            console.log(row.province, +' ' + row.city, +' ' + row.district);
            this.SelectAddress1.province.value = row.province;
            this.SelectAddress1.city.value = row.city;
            this.SelectAddress1.area.value = row.district;
            this.formData.originAddress = row.provinceStr + row.cityStr + row.districtStr;
            this.selectReset = true;
            this.$nextTick(() => {});
        } else {
            console.log('22');
            this.selectReset2 = false;
            this.formData.arrivalProvince = row.province;
            this.formData.arrivalCity = row.city;
            this.formData.arrivalCounty = row.district;
            this.formData.arrivalDetails = row.detail;
            this.formData.consignee = row.contactName;
            this.formData.consigneePhone = row.phoneNumber;
            console.log(row.province, +' ' + row.city, +' ' + row.district);
            this.SelectAddress2.province.value = row.province;
            this.SelectAddress2.city.value = row.city;
            this.SelectAddress2.area.value = row.district;
            this.formData.arrivalAddress = row.provinceStr + row.cityStr + row.districtStr;
            this.selectReset2 = true;
            this.$nextTick(() => {});
        }
        this.handleClose();
    }

    public currentBtn: any = [];

    public addressSearchValue: any = {
        keyWords: '',
    };

    public dialogFormVisible: boolean = false;

    public innerVisible: boolean = false;

    public publicFunc: any = publicFunc;

    public restaurants: any = [];
    goodindex: any = '';
    goodsNameChange(data) {
        console.log('data', data);
        this.goodindex = data;
    }
    async querySearchAsync(queryString, cb) {
        // var res = JSON.parse(localStorage.getItem('contactArr'));
        console.log('data11', this.goodindex);
        var res = await yun.getGoodsPageList({ name: queryString, count: 30 });
        this.restaurants = [];
        if (res) {
            res.data.forEach((item) => {
                this.restaurants.push({
                    value: item.name,
                });
            });
            cb(this.restaurants);
        }
    }
    clearO() {
        this.formData.shipperCode = ''
    }
    clearCu() {
        this.formData.customerBaseId = ''
    }
    clear1() {
        this.formData.consigneeId = ''
    }
    clearA() {
        this.formData.shipperCode = ''
    }
    async querySearchAsyncCu(queryString, cb) {
        console.log('data11', this.formData.customerBaseName);
        let res = await yun.ShipperGetList({
            name: this.formData.customerBaseName,
            type: 1,
            count: 30,
        });
        let dds = [];
        if (res) {
            res.forEach((item) => {
                dds.push({
                    id:item.id,
                    customerBaseCode: item.customerBaseCode,
                    value: item.customerBaseName,
                });
            });
            cb(dds);
        }
        console.log('dds',dds ,res);
    }
    async querySearchAsyncSh(queryString, cb) {
        console.log('data11', this.formData.clientName);
        let res = await yun.GetDropDownList({
            name: this.formData.shipperName,
            type: 1,
            count: 30,
        });
        console.log('data11',res);
        this.restaurants = [];
        if (res) {
            res.forEach((item) => {
                this.restaurants.push({
                    id:item.id,
                    shipperCode:item.code,
                    phone: item.contactPhone,
                    value: item.name,
                    name: item.contactName,
                    defaultAddress: {
                        province: item.province,
                        city: item.city,
                        district: item.county,
                        detail: item.detail,
                    },
                });
            });
            cb(this.restaurants);
        }
    }
    async querySearchAsyncSh1(queryString, cb) {
        console.log('data11', this.formData.clientName);
        let res = await yun.GetDropDownList({
            name: this.formData.consigneeName,
            type: 2,
            count: 30,
        });
        console.log('data11',res);
        this.restaurants = [];
        if (res) {
            res.forEach((item) => {
                this.restaurants.push({
                    id:item.id,
                    code:item.code,
                    phone: item.contactPhone,
                    value: item.name,
                    name: item.contactName,
                    defaultAddress: {
                        province: item.province,
                        city: item.city,
                        district: item.county,
                        detail: item.detail,
                    },
                });
            });
            cb(this.restaurants);
        }
    }
    async querySearchAsync2(queryString, cb) {
        console.log('data11', this.formData.clientName);
        let res = await yun.HistoryContactgetPageList({
            name: this.formData.clientName,
            type: 1,
            count: 30,
        });
        this.restaurants = [];
        if (res) {
            res.data.forEach((item) => {
                this.restaurants.push({
                    phone: item.phoneNumber,
                    value: item.name + '/' + item.phoneNumber,
                    name: item.name,
                });
            });
            cb(this.restaurants);
        }
    }
    async querySearchAsync3(queryString, cb) {
        console.log('data11', this.formData.clientName);
        let res = await yun.HistoryContactgetPageList({
            name: this.formData.consignee,
            type: 2,
            count: 30,
        });
        this.restaurants = [];
        if (res) {
            res.data.forEach((item) => {
                this.restaurants.push({
                    phone: item.phoneNumber,
                    value: item.name + '/' + item.phoneNumber,
                    name: item.name,
                });
            });
            cb(this.restaurants);
        }
    }
    contactChange() {
        this.formData.contactPhone = '';
        // setTimeout(() => {
        //     this.formData.contactPhone = '';
        // }, 1000);
    }

    public mapForm: any = {
        address: '',
        list: [],
        details: '',
    };
    isSelectFahuo;
    public SelectAddress = {
        province: {
            value: '',
            text: '',
        },
        city: {
            value: '',
            text: '',
        },
        area: {
            value: '',
            text: '',
        },
    };
    public SelectAddress2: any = {
        province: {
            value: '',
            text: '',
        },
        city: {
            value: '',
            text: '',
        },
        area: {
            value: '',
            text: '',
        },
    };

    handleSelectCu(item, index) {
        console.log('item', item)
        this.formData.customerBaseCode = item.customerBaseCode
        this.formData.customerBaseId = item.id
    }
    async handleSelectSh(item, index) {
        this.formData.shipperId = item.id
        this.formData.shipperCode = item.shipperCode
        this.formData.shipperName = item.value;
        this.addressType = 1;
        if (item.defaultAddress) {
            await this.saveAddress(item.defaultAddress)
        }
        this.formData.shipperContactName = item.name;
        this.formData.shipperContactPhone = item.phone;
        console.log('item.shipperCode', item.shipperCode,this.formData)
    }
    async handleSelectSh1(item, index) {
        this.formData.consigneeId = item.id;
        this.formData.consigneeName = item.value
        this.formData.consigneeCode = item.code
        this.addressType = 2;
        if (item.defaultAddress) {
            await this.saveAddress(item.defaultAddress)
        }
        this.formData.consignee = item.name;
        this.formData.consigneePhone = item.phone;
    }
    handleSelect2(item, index) {
        this.formData.shipperContactPhone = item.phone;
        this.formData.shipperContactName = item.name;
    }
    handleSelect3(item, index) {
        this.formData.consigneePhone = item.phone;
        this.formData.consignee = item.name;
    }
    handleSelect(item, index) {
        let res = this.restaurants.filter((v) => v.value == item)[0];
        this.goodsForm.goodsList[index].materialsName = res.value;
    }
    public goodsForm: any = {
        goodsList: [
            {
                deliveryOrderNo: '',
                deliveryLine: '',
                materialsCode: '',
                materialsName: '',
                planQuantity: '',
                planWeight: '',
                fabricWidth: '',
                storageCode: '',
                sort: 1,
                index: 1,
            },
        ],
    };

    public SelectAddress1 = {
        province: {
            value: '',
            text: '',
        },
        city: {
            value: '',
            text: '',
        },
        area: {
            value: '',
            text: '',
        },
    };

    /**
     * 基本信息
     */
    public fileList: any = [];

    public status: string = '0';

    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        this.loadAddress();
    }

    public handleClose() {
        this.addressChooseVisible = false;
        this.addressSearchValue.keyWords = '';
    }

    //---地址选择start---
    public selectReset: boolean = false;

    public selectReset2: boolean = false;

    onMarkersSetList: any = [];

    public page: any = 'add';

    public getLoadTypeList: any = [];
    /**历史货物列表 */
    historyGoodsList = [];

    goodsListRes: any = [];
    /** 获取货物列表*/
    public querySearchGoodsList(queryString, cb) {
        CspInquiry.getGoodsList({
            goodstypeid: '',
            goodsName: queryString,
            job: '',
            skip: 0,
            count: -1,
        }).then((res) => {
            let list = [];
            this.historyGoodsList = res.data;
            res.data.forEach((item) => {
                list.push({
                    value: item.name,
                    id: item.id,
                });
            });
            this.goodsListRes = list;
            cb(list);
        });
    }
    public handleSelectGoods(item, index) {
        let res = this.goodsListRes.filter((v) => v.value == item)[0];
        this.goodsForm.goodsList[index].goodsName = res.value;
        this.goodsForm.goodsList[index].goodsId = res.id;
    }

    /**装车要素 */
    getLoadType() {
        yun.GetDicList({ typeName: 'loadingEffect' }).then((res) => {
            // this.getLoadTypeList = res.map((v) => {
            //     return v.stringData;
            // });
            this.getLoadTypeList = res;
        });
    }
    viewFile(item) {
        if (publicFunc.getExtension2(item.name)) {
            window.open(`https://view.officeapps.live.com/op/view.aspx?src=${item.url}`);
        } else {
            window.open(item.url);
        }
    }

    customerList = [];
    /** 获取客户代表列表*/
    public combination: string = '';
    public querySearchCustomer(queryString, cb) {
        this.formData.customerId = '';
        CspInquiry.customerRepresentative({
            enterpriseid: '',
            realName: this.formData.customerName,
            job: '',
            isEnabled: true,
            skip: 0,
            count: -1,
        }).then((res) => {
            this.vehicleTypeList = [];
            this.customerList = res.data;
            res.data.forEach((item) => {
                this.combination = item.realName + (item.phoneNumber ? '/' + item.phoneNumber : '');
                this.vehicleTypeList.push({
                    // value: item.realName,
                    id: item.phoneNumber,
                    value: this.combination,
                });
            });
            cb(this.vehicleTypeList);
        });
    }
    // public handleSelect(val) {
    //     console.log('val' + JSON.stringify(val));
    //     this.contactArr.forEach((v) => {
    //         if (v.contact == val.contact) {
    //             this.formData.contact = v.contact;
    //             this.formData.contactPhone = v.contactPhone;
    //         }
    //     });
    // }

    public handleRemove(file, fileList) {
        this.fileList = fileList;
    }

    public handlePreview(file, name) {
        console.log(file);
    }
    public isload:any = 0
    public loadcc:any = 0

    public async handleChange(file, fileList) {
        if (this.fileList.length == 5) {
            this.$message.warning('最多上传5个附件!');
            return;
        }
        var theFile = file.raw;
        //实例化一个文件读取器
        var fileReader = new FileReader();
        //将用户上传的文件对象作为参数，传入文件读取器的方法readAsDataURL
        fileReader.readAsDataURL(theFile);
        let that = this;
        fileReader.onload = function () {};
        let size = theFile.size / 1024;
        console.log(theFile);

        if (!publicFunc.isFile(file.name)) {
            this.$message.error('请上传规定格式文件');
            return;
        }
        if (size > 51200) {
            this.$message.error('文件大小超过50M');
            return;
        }
        this.isload = 1
        this.loadcc = 0
        let timego:any = setInterval(_=>{
            if (this.loadcc > 99) {
                this.isload = 2
                clearInterval(timego)
            } else {
                if (this.loadcc < 80 || this.loadcc > 85) {
                    this.loadcc =  this.loadcc + 1
                }
            }
        },100)
        const res = await upload(theFile, file.name);
        this.loadcc = 90
        setTimeout(_=> {
            this.isload = 0
            var imageUrl = res.res.requestUrls[0].split('?')[0];
            this.fileList.push({ name: file.name, url: imageUrl });
        },1500)
        console.log('res', res)

    }

    removeImage(index) {
        this.fileList.splice(index, 1);
    }

    public async updateReset() {
        this.selectReset = false;
        this.selectReset2 = false;
    }
    originProvince: any = '';
    public async getProvince(item, name) {
        this.formData.originProvince = item;
        this.originProvince = name;
        this.formData.originCity = '';
        this.originCity = '';
        this.formData.originCounty = '';
        this.originCounty = '';
        this.formData.originAddress = this.originProvince;
        this.GetPrice();
    }
    originCity: any = '';
    public async getCityCode(item, name) {
        this.formData.originCity = item;
        this.originCity = name;
        this.formData.originCounty = '';
        this.originCounty = '';
        this.formData.originAddress = this.originProvince + this.originCity;
        console.log('addresname', this.originProvince + this.originCity);
        this.getMileageSimple();
        this.GetPrice();
    }
    originCounty: any = '';
    public getName1(data, names, named) {
        this.formData.originAddress = data;
        if (names) {
            this.originProvince = names;
            this.originCity = named;
        }
    }
    public getName2(data, names, named) {
        console.log('2name', data, names);
        this.formData.arrivalAddress = data;
        if (names) {
            this.arrivalProvince = names;
            this.arrivalCity = named;
        }
    }
    public async getAreaCode(item, name) {
        this.formData.originCounty = item;
        this.originCounty = name;
        this.formData.originAddress = this.originProvince + this.originCity + this.originCounty;
        this.getMileageSimple();
        this.GetPrice();
    }
    arrivalProvince: any = '';
    arrivalCounty: any = '';
    arrivalCity: any = '';
    public async getProvince2(item, name) {
        this.formData.arrivalProvince = item;
        this.arrivalProvince = name;
        this.formData.arrivalCity = '';
        this.arrivalCity = '';
        this.formData.arrivalCounty = '';
        this.arrivalCounty = '';
        console.log('xxxxx', item);
        this.formData.arrivalAddress = this.arrivalProvince;
        this.GetPrice();
    }

    public async getCityCode2(item, name) {
        this.formData.arrivalCity = item;
        this.arrivalCity = name;
        this.formData.arrivalCounty = '';
        this.arrivalCounty = '';
        console.log('addresname', this.arrivalProvince + this.arrivalCity);
        this.formData.arrivalAddress = this.arrivalProvince + this.arrivalCity;
        this.getMileageSimple();
        this.GetPrice();
    }

    public async getAreaCode2(item, name) {
        this.formData.arrivalCounty = item;
        this.arrivalCounty = name;
        this.formData.arrivalAddress = this.arrivalProvince + this.arrivalCity + this.arrivalCounty;
        this.getMileageSimple();
        this.GetPrice();
    }

    updateBtn(item, index) {
        // loadingEffect
        // if (this.currentBtn.includes(item)) {
        //     this.currentBtn.splice(this.currentBtn.indexOf(item), 1);
        // } else {
        //     this.currentBtn.push(item);
        // }
        if (this.currentBtn.includes(item)) {
            this.currentBtn.splice(this.currentBtn.indexOf(item), 1);
        } else {
            this.currentBtn.push(item);
        }
    }

    addGood() {
        this.goodsForm.goodsList.push({
            index: this.goodsForm.goodsList.length + 1,
            deliveryOrderNo: '',
            deliveryLine: '',
            materialsCode: '',
            materialsName: '',
            planQuantity: '',
            planWeight: '',
            fabricWidth: '',
            storageCode: '',
            sort: this.goodsForm.goodsList.length + 1,
        });
        this.formData.planTotalWeight = 0
        this.goodsForm.goodsList.forEach(item =>  {
            this.formData.planTotalWeight = (Number(this.formData.planTotalWeight) + Number(item.planWeight)).toFixed(2)
        })
        if( this.formData.planTotalWeight == 0) {
            this.formData.planTotalWeight = ''
        }

    }
    changeww() {
        this.formData.planTotalWeight = 0
        this.goodsForm.goodsList.forEach(item =>  {
            this.formData.planTotalWeight = (Number(this.formData.planTotalWeight) + Number(item.planWeight)).toFixed(2)
        })

        if (this.formData.planTotalWeight == 0) {
            this.formData.planTotalWeight = ''
        }
    }
    removeGood(index) {
        this.goodsForm.goodsList.splice(index, 1);
    }
    map: any;
    async openAddressBook(type) {
        if(this.canedit) {
            return
        }
        this.selectReset = false;
        this.selectReset2 = false;
        this.addressType = type;
        this.addressChooseVisible = true;
        this.loadAddress();
    }

    public local: any = null;
    resetSearchValue() {
        this.addressSearchValue = {
            keyWords: '',
        };
        this.loadAddress();
    }

    public tableData: any = [
        {
            name: '11',
        },
    ];
    public total = 0;
    public async loadAddress() {
        this.loading = true;
        try {
            let res = await yun.GetAddressBookList({
                ...this.addressSearchValue,
                addressType: this.addressType,
                isDefault: false,
                skip: this.searchPagin.skip,
                count: this.searchPagin.count,
            });
            this.tableData = res.data;
            let skip = this.searchPagin.skip;
            this.$refs.pagination.setPage(this.searchPagin.currentPage);
            this.tableData.map((item, index) => {
                item.index = skip++ + 1;
            });
            this.total = res.total;
            this.loading = false;
        } catch {
            this.loading = false;
        }
    }
    searchFunc() {
        this.$refs.pagination.handleCurrentChange(1);
        this.searchPagin.skip = 0;
    }

    public dialogStatus: string = 'add';
    public currentIndex: number = 0;

    public removeIndex = null;

    public btt:any = 0
    public ssid:any = ''
    public dialogConfig: any = {
        title: '终结该运单',
        show: false,
    };
    confirmClose() {
        this.dialogConfig = {
            title: '',
            show: false,
        };
    }
    /**新增询价单 */
    async confirmOk() {
        if (this.btt == 4 && this.$route.query.type != 'edit') {
            this.formData.originAddress = this.formData.originAddress + this.formData.originDetails;
            this.formData.arrivalAddress =   this.formData.arrivalAddress  + this.formData.arrivalDetails;
            yun.addOrder(this.formData).then(() => {
                this.$message.success('计划保存成功');
                let obj = {
                    contact: this.formData.contact,
                    contactPhone: this.formData.contactPhone,
                };
                let contactArr = JSON.parse(localStorage.getItem('contactArr'));
                if (contactArr) {
                    contactArr.push(obj);
                    localStorage.setItem('contactArr', JSON.stringify(this.removeDuplicateObj(contactArr).reverse()));
                } else {
                    localStorage.setItem('contactArr', JSON.stringify([obj]));
                }

                this.$router.push('/orderManager');
            });
        }else {
            this.formData.originAddress = this.originProvince + this.originCity + this.originCounty + this.formData.originDetails;
            this.formData.arrivalAddress =   this.formData.arrivalAddress  + this.formData.arrivalDetails;
            yun.saveOrder({
                id: this.$route.query.id,
                ...this.formData,
            }).then(() => {
                this.$message.success('发货计划更新成功');
                let obj = {
                    contact: this.formData.contact,
                    contactPhone: this.formData.contactPhone,
                };
                let contactArr = JSON.parse(localStorage.getItem('contactArr'));
                if (contactArr) {
                    contactArr.push(obj);
                    localStorage.setItem('contactArr', JSON.stringify(this.removeDuplicateObj(contactArr).reverse()));
                } else {
                    localStorage.setItem('contactArr', JSON.stringify([obj]));
                }

                this.$router.push('/orderManager');
            })
        }
        this.dialogConfig = {
            show: false,
        };
    }
    /**是否更新公里数 */
    public mileageChange: boolean = true;

    public dialogBtn: string = '';
    /**新增询价单 */
    public async addInquiry(dds) {
        this.formData.orderGoodsList = this.goodsForm.goodsList;
        if (this.formData.orderGoodsList.length == 0) {
            this.$alert('货物信息不能少于1条');
            return;
        }
        var date1 = new Date(this.formData.latestDeliveryTime)
        var date2 = new Date(this.formData.latestArrivalTime)
        if (this.formData.latestDeliveryTime && this.formData.latestArrivalTime && (date2 < date1)) {
            this.$alert('最晚到货时间不能小于最晚发货时间');
            return;
        }
        let istabe: any = false;
        this.formData.orderGoodsList.forEach((item) => {
            if (item.planWeight) {
                try {
                    let nn = (item.planWeight + '').split('.')[1];
                    if (nn.length > 4) {
                        item.planWeight = Number((item.planWeight + '').split('.')[0] + '.' + nn.slice(0, 4));
                    }
                } catch (e) {}
                if (!Number(item.planWeight+ '')) {
                    item.planWeight = ''
                    // istabe = true;
                }else {
                    item.planWeight = Number(item.planWeight)
                }
            }
            if (!item.materialsName) {
                istabe = true;
            }
        });

        if (istabe) {
            this.$alert('请把货物信息填写正确完整');
            return;
        }
        this.formData.attachmentList = this.fileList.map((v) => {
            return {
                name: v.name,
                path: v.url,
            };
        });

        this.formData.loadingEffect = '';

        console.log(this.currentBtn);
        this.currentBtn.forEach((data,index) => {
            console.log('data', data.name);
            if(index != 0) {
                this.formData.loadingEffect = this.formData.loadingEffect + ',' + data.name ;
            } else {
                this.formData.loadingEffect = this.formData.loadingEffect + data.name ;
            }
        });
        console.log('this.formData', this.formData);
        console.log(this.formData.originAddress, this.originProvince, this.originCity, this.originCounty);
        // return
        let address1 = this.$refs.address1.validateForm();
        let address2 = this.$refs.address2.validateForm();
        // let goodsForm = this.goodsListvalidateForm();
        this.$refs.formData.validate((valid) => {
            if (address1 && address2 && this.formData.orderGoodsList.length && valid) {
                console.log('this.formData' + this.formData);
                if (dds == 1) {
                    this.btt = 4
                    this.dialogConfig = {
                        title: '保存',
                        show: true,
                    };
                } else {
                    this.btt = 4
                    this.dialogConfig = {
                        title: '更新发货计划',
                        show: true,
                    };
                }
            }
        });
    }
    removeDuplicateObj(arr) {
        let obj = {};
        arr = arr.reduce((newArr, next) => {
            obj[next.contact] ? '' : (obj[next.contact] = true && newArr.push(next));
            return newArr;
        }, []);
        return arr;
    }

    public goodsListvalidateForm() {
        let flag = false;
        this.$refs.goodsForm.validate((valid) => {
            flag = valid;
        });
        return flag;
    }

    viewInquiry(data) {
        if (this.goodsForm.goodsList.length == 1) {
            this.$alert('至少保留一条货物数据')
            return
        }
        console.log('dd',data.sort)
        this.goodsForm.goodsList.splice((data.sort-1),1)
        let skip = 0
        this.formData.planTotalWeight = 0
        this.goodsForm.goodsList.map((item, index) => {
            // if (item.unit == 1) {
            this.formData.planTotalWeight = (Number(this.formData.planTotalWeight) + Number(item.planWeight)).toFixed(2)
            // }
            item.index = index + 1;
            item.sort = index + 1;
        })
        if (this.formData.planTotalWeight == 0)  {
            this.formData.planTotalWeight = ''
        }
    }

    public getMileageSimple() {
        // 里程字段mileage后端已于4724a8b84596ade05a02db31762a92603acc625e提交中去除，这里代码无用
    }

    cspdiaClose() {}
    gogo() {
        this.$router.push('/orderManager');
    }
    back() {
        // this.$router.push('/SingleInquiry');
        this.$router.go(-1);
    }

    public startPlaceLongitude = '';
    public startPlaceLatitude = '';

    /**
     * 高德关键词检索(发货地址)
     */
    public async querySearchStartAsync(queryString, cb) {

        if (queryString.length < 2) return;

        this.startPlaceLongitude = '';
        this.startPlaceLatitude = '';
        const data = [];

        // 配置搜索参数（参考网页1/3/6）
        // this.originCounty ||
        const searchOptions = {
            city: this.originCity || '全国', // 优先区县>城市>全国
            pageSize: 20,          // 每页结果数
            pageIndex: 1,          // 页码
            extensions: 'all'      // 返回完整信息
        };

        // 初始化地点搜索服务（参考网页1/6）
        AMap.plugin('AMap.PlaceSearch', () => {
            const placeSearch = new AMap.PlaceSearch(searchOptions);

            // 执行搜索请求
            placeSearch.search(queryString, (status, result) => {
                if (status === 'complete' && result.info === 'OK') {
                    const pois = result.poiList.pois;

                    pois.forEach(poi => {
                        // 解析坐标点（高德返回格式："经度,纬度"）
                        const [lng, lat] = poi.location.pos

                        data.push({
                            title: poi.name,
                            address: `${poi.cityname}${poi.adname}${poi.address}`,
                            searchvalue: `${poi.name}${poi.address ? '('+poi.address+')' : ''}`,
                            point: {
                                lng: lng,
                                lat: lat
                            }
                        });
                    });

                    // 返回格式化数据
                    cb(data.map(e => ({
                        title: e.title,
                        address: e.address,
                        value: e.searchvalue,
                        point: e.point
                    })));
                } else {
                    console.error('搜索失败:', result.info);
                    cb([]);
                }
            });
        });
    }


    /**
     * 地址选择（发货地址）
     */
    public handlStarteSelect(item) {
        this.startPlaceLongitude = item.point.lng;
        this.startPlaceLatitude = item.point.lat;
        this.getMileageSimple();
    }

    public destinationLongitude = '';
    public destinationLatitude = '';

    /**
     * 高德关键词检索(送货地址)
     */
    public async querySearchDestinationAsync(queryString, cb) {

        if (queryString.length < 2) return;

        this.destinationLongitude = '';
        this.destinationLatitude = '';
        const data = [];

        // 配置搜索参数（参考网页1/3/6）
        // this.originCounty ||
        const searchOptions = {
            city: this.arrivalCounty || '全国', // 优先区县>城市>全国
            pageSize: 20,          // 每页结果数
            pageIndex: 1,          // 页码
            extensions: 'all'      // 返回完整信息
        };

        // 初始化地点搜索服务（参考网页1/6）
        AMap.plugin('AMap.PlaceSearch', () => {
            const placeSearch = new AMap.PlaceSearch(searchOptions);

            // 执行搜索请求
            placeSearch.search(queryString, (status, result) => {
                if (status === 'complete' && result.info === 'OK') {
                    const pois = result.poiList.pois;

                    pois.forEach(poi => {
                        // 解析坐标点（高德返回格式："经度,纬度"）
                        const [lng, lat] = poi.location.pos

                        data.push({
                            title: poi.name,
                            address: `${poi.cityname}${poi.adname}${poi.address}`,
                            searchvalue: `${poi.name}${poi.address ? '('+poi.address+')' : ''}`,
                            point: {
                                lng: lng,
                                lat: lat
                            }
                        });
                    });

                    // 返回格式化数据
                    cb(data.map(e => ({
                        title: e.title,
                        address: e.address,
                        value: e.searchvalue,
                        point: e.point
                    })));
                } else {
                    console.error('搜索失败:', result.info);
                    cb([]);
                }
            });
        });
    }

    detailsBlur() {
        // this.getMileageSimple();
    }
    /**
     * 地址选择（送货地址）
     */
    public handlDestinationeSelect(item) {
        this.destinationLongitude = item.point.lng;
        this.destinationLatitude = item.point.lat;
        this.getMileageSimple();
    }
    public content1 = '';
    public content2 = '';

    selectList = [];
    public carCodeEnd() {
        console.log('cc2');
        if (!this.formData.carrierId) {
            this.formData.carrierName = '';
        }
    }
    public carCodechange(val) {
        this.formData.carrierId = '';
    }
    async querySearch1(queryString, cb) {
        let res = await yun.GetCarrierList({ Name: this.formData.carrierName,count:-1 });
        console.log(res.data);
        let result = [];
        res.data.forEach((dd) => {
            let xx = {
                value: dd.name,
                id: dd.id,
            };
            result.push(xx);
        });
        this.selectList = result;
        cb(result);
    }
    selectCar1(data) {
        this.formData.carrierId = data.id;
        this.GetPrice();
    }
    async AddressDistinguishs(data, index) {
        if (index == 1) {
            this.selectReset = false;
            let res = await yun.AddressDistinguish({ text: data });
            this.formData.originProvince = res.province;
            this.formData.originCity = res.city;
            this.formData.originCounty = res.county;
            this.SelectAddress1.province.value = res.province;
            this.SelectAddress1.city.value = res.city;
            this.SelectAddress1.area.value = res.county;
            this.formData.originDetails = res.details;
            this.formData.originAddress = res.address;
            this.formData.clientName = res.name;
            this.formData.clientPhone = res.phone;
            this.selectReset = true;
        } else {
            this.selectReset2 = false;
            let res = await yun.AddressDistinguish({ text: data });

            this.formData.arrivalProvince = res.province;
            this.formData.arrivalCity = res.city;
            this.formData.arrivalCounty = res.county;
            this.formData.arrivalDetails = res.details;
            this.formData.consignee = res.name;
            this.formData.consigneePhone = res.phone;
            this.SelectAddress2.province.value = res.province;
            this.SelectAddress2.city.value = res.city;
            this.SelectAddress2.area.value = res.county;
            this.formData.arrivalAddress = res.address;
            this.selectReset2 = true;
        }
    }
    getWidth(data) {
        let flexWidth = 0
        for (const char of data) {
            if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
                // 如果是英文字符，为字符分配8个单位宽度
                flexWidth += 9;
            } else if (char >= '\u4e00' && char <= '\u9fa5') {
                // 如果是中文字符，为字符分配15个单位宽度
                flexWidth += 16;
            } else {
                // 其他种类字符，为字符分配8个单位宽度
                flexWidth += 9;
            }
        }
        console.log('flexWidth',flexWidth)
        return flexWidth + 20
    }
    async GetPrice() {
        this.SinglePriceList = []
        if (!this.formData.carrierId) {
            return;
        }
        if (!this.formData.pricingMode) {
            return;
        }
        let data = {
            carrierId: this.formData.carrierId,
            priceListType: this.formData.pricingMode,
            deliveryProvince: this.originProvince,
            deliveryCity: this.originCity,
            deliveryArea: this.originCounty,
            arrivalProvince: this.arrivalProvince,
            arrivalCity: this.arrivalCity,
            arrivalArea: this.arrivalCounty,
            titleName: this.formData.carLength,
        };
        let res = await yun.getSinglePriceList(data);
        this.SinglePriceList = res.priceListDetails[0].priceContent
        // this.formData.freightUnitPrice = res.extData;
        console.log('this.SinglePriceList', this.SinglePriceList,res);
        if (this.SinglePriceList.length) {
            this.freightSourceList.push({ key: '2', value: 2, label: '运价表' })
        }
    }
    public SinglePriceList:any= []
    handleInput(e,index){
        e.target.value= e.target.value.match(/\d{1,9}(\.\d{0,4})?/) ? e.target.value.match(/\d{1,9}(\.\d{0,4})?/)[0] : ''
        this.goodsForm.goodsList[index].planQuantity = e.target.value;
    }
    handleInputPlanWeight(e,index){
        e.target.value= e.target.value.match(/\d{1,9}(\.\d{0,2})?/) ? e.target.value.match(/\d{1,9}(\.\d{0,2})?/)[0] : ''
        this.goodsForm.goodsList[index].planWeight = e.target.value;
    }
    handleInputfabricWidth    (e,index){
        e.target.value= e.target.value.match(/\d{1,9}(\.\d{0,2})?/) ? e.target.value.match(/\d{1,9}(\.\d{0,2})?/)[0] : ''
        this.goodsForm.goodsList[index].fabricWidth  = e.target.value;
    }
    handleInput1(e,index){
        e.target.value= e.target.value.match(/\d{1,9}(\.\d{0,2})?/) ? e.target.value.match(/\d{1,9}(\.\d{0,2})?/)[0] : ''
        this.formData.freightUnitPrice = e.target.value;
    }
    public async exportExcel1() {
        let data = await yun.GetOrderGoodsTemplate('');
    }
    errList:any = []
    batchImportList:any = []
    errorType:any = ''
    async updateImage(e: any) {
        this.errList = []
        let param = new FormData();
        const file = e.file;
        param.append('excel', file);
        let resd = await yun.uploadGoodsExcel(param);
        this.goodsForm.goodsList = []
        this.formData.planTotalWeight = 0
        resd.forEach((data,index)=> {
            if (data.planWeight) {
                this.formData.planTotalWeight = (Number(this.formData.planTotalWeight) + Number(data.planWeight)).toFixed(2)
            }
            let xx = {
                index: this.goodsForm.goodsList.length + 1,
                sort: this.goodsForm.goodsList.length + 1,
                deliveryOrderNo: data.deliveryOrderNo,
                deliveryLine: data.deliveryLine,
                materialsCode: data.materialsCode,
                materialsName: data.materialsName,
                planQuantity: data.planQuantity,
                planWeight: data.planWeight,
                fabricWidth: data.fabricWidth,
                storageCode: data.storageCode,
            }
            this.goodsForm.goodsList.push(xx)
        })
        this.$message.success('导入成功!');
        // if (!resd.validity) {
        //     this.errorType = resd.validityStatus;
        //     if (this.errorType == 1) {
        //         if (resd.orderGoodsList.length == 0) {
        //             this.$message.error('Excel表格为空，无法上传！');
        //         } else {
        //             this.$message.error('一次最多上传1000条货物，请删减后重新上传！');
        //         }
        //     }
        //     if (this.errorType == 2) {
        //         this.errList = [];
        //         this.errList = resd.errRowCellList;
        //         this.batchImportList = [];
        //         console.log('res.orderGoodsList' + JSON.stringify(resd.orderGoodsList));
        //         resd.orderGoodsList.forEach((item) => {
        //             this.batchImportList.push(item);
        //         });
        //         this.dialogVisible = true;
        //         console.log('this.errList' + JSON.stringify(this.errList));
        //     } else if (this.errorType == 3) {
        //         this.errList = resd.repeatRow;
        //         this.batchImportList = [];
        //         resd.orderGoodsList.forEach((item) => {
        //             this.batchImportList.push(item);
        //         });
        //         this.dialogVisible = true;
        //     }
        // } else {
        //     console.log(resd)
        //     this.goodsForm.goodsList = []
        //     this.formData.planWeight = 0
        //     resd.orderGoodsList.forEach((data,index)=> {
        //         if (data.unit == 1) {
        //             this.formData.planWeight = Number(this.formData.planWeight) + Number(data.quantity)
        //         }
        //         let xx = {
        //             index: this.goodsForm.goodsList.length + 1,
        //             id: '',
        //             model: data.model,
        //             goodsName: data.goodsName,
        //             quantity: data.quantity,
        //             remark: data.remark,
        //             unit: data.unit,
        //         }
        //         this.goodsForm.goodsList.push(xx)
        //     })
        //     this.$message.success('导入成功!');
        // }
    }
    handleClose2() {
        this.dialogVisible = false
    }
    handleClose1() {
        this.formData.freightSource = ''
        this.formData.carrierName = ''
        this.formData.carrierId = ''
        this.carrierVisible = false
    }
    save() {

    }
    dialogVisible:any = false
    cellClass({ row, column, rowIndex, columnIndex }) {
        let isr = false
        this.errList.forEach(data => {
            // console.log(columnIndex,rowIndex,data,data.cell,data.row-1,this.errList)
            if (columnIndex == data.cell && rowIndex == Number(data.row) - 1) {
                isr = true
            } else {
            }
        })
        console.log(rowIndex, columnIndex,isr)
        if (isr) {
            return 'border: 2px dashed #f11;position: relative;top:-1px';
        } else {
            return '';

        }
        // for (let i = 0; i < .length; ) {
        //     console.log(columnIndex,rowIndex,i,this.errList[i].cell,Number(this.errList[i].row) - 1,this.errList)
        //
        //
        // }
    }
    getRowKey(row) {
        return row.id
    }

    public paginationOptions = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public pageSizes = [50];
    public lastPageNum = 0;
    public pageSize: number = 50;
    public firstPageBtnDisabled = true;
    public lastPageBtnDisabled = false;
    public handleCurrentChange(val) {
        console.log('onPaginationChange', val);
        this.firstPageBtnDisabled = val === 1 ? true : false;
        this.lastPageBtnDisabled = val === Math.ceil(this.total / this.paginationOptions.count) ? true : false;
        this.paginationOptions.currentPage = val;
        this.paginationOptions.skip = (this.paginationOptions.currentPage - 1) * this.paginationOptions.count;
        console.log('this.paginationOptions~', this.paginationOptions);
    }
    public handleSizeChange(val) {
        console.log('handleSizeChangeval' + JSON.stringify(val));

        this.paginationOptions.count = val;
        this.paginationOptions.currentPage = 1;
        this.handleCurrentChange(this.paginationOptions.currentPage);
        if (Math.ceil(this.total / val) < this.paginationOptions.currentPage) {
            this.paginationOptions.skip = 0;
        } else {
            this.paginationOptions.skip = (this.paginationOptions.currentPage - 1) * this.paginationOptions.count;
        }
    }
    handleInput2(e, index) {
        e.target.value = e.target.value.match(/\d{1,9}(\.\d{0,2})?/) ? e.target.value.match(/\d{1,9}(\.\d{0,2})?/)[0] : '';
        this.formData.planTotalWeight = e.target.value;
    }
    must(obj){
        if(obj.columnIndex == 3  ){
            return 'must'
        }
    }
}
